import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { isEntryPaid } from '../utils/paymentLock';

/**
 * Redirect to the payment success page if the given entry has already been paid.
 *
 * Runs on mount/when ids change and also on `pageshow` with `event.persisted`, so
 * a page restored from the back/forward cache (bfcache) with stale, already-paid
 * wizard state can't be edited or re-submitted.
 *
 * @param {{ couponId?: number|string|null, popinId?: number|string|null, enabled?: boolean }} params
 */
export function usePaymentLockGuard({ couponId, popinId, enabled = true } = {}) {
  const navigate = useNavigate();

  useEffect(() => {
    if (!enabled) return undefined;

    const check = () => {
      if (isEntryPaid({ couponId, popinId })) {
        navigate('/payment/success', { replace: true });
      }
    };

    check();

    const onPageShow = (event) => {
      if (event.persisted) check();
    };
    window.addEventListener('pageshow', onPageShow);
    return () => window.removeEventListener('pageshow', onPageShow);
  }, [couponId, popinId, enabled, navigate]);
}
